import SiteManagerView from "./SiteManagerView";
import SiteTreeBuilder from "./SiteTreeBuilder";
import DeviceDetailsView from "./DeviceDetailsView";
import TemsWebEvents from "@/TemsWebEvents";
import { SiteViewModel, LocationViewModel, ElementViewModel, ElementTypeViewModel, TriggerLocationViewModel, MeshTransform } from "@/TemsManagerWebInterface";
import Localization from "@/Localization";
import { ViewModelUserLevel } from 'Tems/Security/TemsPolicy';
import "bootstrap-slider"
var Sortable = require('sortablejs');

export default class SiteTreeView {

    private siteManagerView: SiteManagerView;
    private siteTreeBuilder: SiteTreeBuilder;
    private deviceDetailsView: DeviceDetailsView;

    private pendingTriggerUpdates: { [id: string]: TriggerLocationViewModel[]; } = {};
    private pendingTriggerUpdateHandle: number | null = null;

    private pendingPositionUpdates: { [id: string]: MeshTransform; } = {};
    private pendingPositionUpdateHandle: number | null = null;

    constructor(siteManagerView: SiteManagerView, domElement: JQuery) {
        this.siteManagerView = siteManagerView;
        this.deviceDetailsView = new DeviceDetailsView(siteManagerView);
        this.siteTreeBuilder = new SiteTreeBuilder(this, siteManagerView);

        TemsWebEvents.subscribeEvent(TemsWebEvents.TriggerLinesChanged, (evt, deviceId) => {
            this.triggerLinesChanged(deviceId);
        });

        TemsWebEvents.subscribeEvent(TemsWebEvents.DevicePositionChanging, (evt, deviceId) => {
            this.devicePositionChanging(deviceId);
        });

        // prevent key events from bubbeling outside the tableSiteTree
        domElement.keydown((evt) => {
            evt.stopPropagation();
        });

        $("#modalAddElementSearch").on("keyup", () => this.modalAddElementFilterEntries());
    }

    public updateSiteTree(newSite: SiteViewModel, oldSite: SiteViewModel): boolean {
        var siteTreeModelChanged = this.siteTreeBuilder.updateSiteTree(newSite, oldSite);

        // Details click handler
        $("#tableSiteTree").unbind('click');
        $("#tableSiteTree").on('click', '.sitetree-entry,#sitetree-pluginRootElement', event => {
            // Don't stop the propagation of this event! it breaks bootstraps dropdown controls!

            if ($(event.target).hasClass("showElementDetails") || $(event.target).parent("div").hasClass("showElementDetails")) {
                if ($(event.target).hasClass("siteEditable") && this.siteManagerView.IsInEditMode) {
                    return;
                }

                var element: JQuery;
                if ($(event.target).hasClass("showElementDetails")) {
                    element = $(event.target).parent("div").parent("li");
                } else {
                    element = $(event.target).parent("div .showElementDetails").parent("div").parent("li");
                }

                var id = element.data("id");
                this.siteManagerView.selectElement(id);
            }
        });

        // Make all unordered lists sortable
        $.each($("#tableSiteTree").find("ul.sortableElement"), (idx, ulSortableElement) => {
            new Sortable(ulSortableElement, {
                // we're missing the typescript-module for sortable as jquery addon
                handle: ".element-image",
                onEnd: (evt: OnEndEvt) => {
                    if (evt.oldIndex !== evt.newIndex) {
                        let elementId = evt.item.getAttribute("data-id");
                        this.siteManagerView.changeSequenceNumber(elementId, evt.oldIndex, evt.newIndex);
                    }
                },
                "disabled": !this.siteManagerView.IsInEditMode
            })
        });


        // This is a hack that shouln't be needed! it actually disables any editables if we're not in edit mode
        // That should have happened in the 'switchToEditMode' method from the SiteManagerView, but ATM it is called too early...
        if (!this.siteManagerView.IsInEditMode) {
            $(".siteEditable").editable("disable");
            $(".sliderInput.editControlVisible").slider("disable");
            $("#sitetree-pluginRootElement").toggle($("#sitetree-pluginRootElement").find("li").length > 0);
        } else {
            $(".siteEditable").editable("enable");
            $(".sliderInput.editControlVisible").slider("enable");
            $("#sitetree-pluginRootElement").show();
        }

        return siteTreeModelChanged;
    }

    /*
     * Update DOM / WebGL when Health oder States are changed
     */
    public displayElementState(element: ElementViewModel, isSelected: boolean) {
        var elem = $(`#element-${element.Id}`);
        if (elem.length) {
            elem.removeClass("label-default label-success label-warning label-danger")
                .addClass(`label-${Localization.translateHealth(element.Health)}`);
        }

        elem.parent().parent().toggleClass("siteTreeSelected", isSelected);
    }

    public deviceToggleEnableState(id: string, domElement: JQuery<Element>) {
        this.siteManagerView.changeUserLevel(ViewModelUserLevel.AuthorizedClient).then(() => {
            $.ajax({
                url: `/api/SiteEdit/ToggleDeviceEnabled/${id}`,
                method: "POST"
            }).done(() => {
                domElement.toggleClass("glyphicon-check");
                domElement.toggleClass("glyphicon-unchecked");
                this.siteManagerView.forceSiteModelAndViewUpdate();
            }).fail(err => {
                this.siteManagerView.showAlertMessage(Localization.resourceStrings.SiteView_ErrorChangeEnabled.replace("{0}", id), err.responseJSON.Message, Localization.resourceStrings.SiteView_ErrorExceptionMessageTemplate);
            });
        });
    }

    public enableLink(deviceId, outputName, linkId) {
        this.siteManagerView.changeUserLevel(ViewModelUserLevel.AuthorizedClient).then(() => {
            $.post(`/api/SiteEdit/ActivateLink/${linkId}`)
                .done(() => {
                    // Link Name probably OutputName
                    var addLinkDropdown = $(`#add-links-dropdown-${deviceId}-${outputName}`);
                    var selectedItemDom = addLinkDropdown.children(`[data-id='${linkId}']`);
                    //var linkId = selectedItemDom.attr('data-id');
                    selectedItemDom.remove();

                    var link = this.siteManagerView.getObjectFromSiteById(linkId);

                    this.siteTreeBuilder.linksControls[deviceId].appendLinkToEnabledList(link, deviceId, outputName);
                }).fail(() => {
                    alert("failed to activate link");
                });
        });
    }

    public disableLink(deviceId, outputName, linkId): void {
        this.siteManagerView.changeUserLevel(ViewModelUserLevel.AuthorizedClient).then(() => {
            $.post(`/api/SiteEdit/DeactivateLink/${linkId}`)
                .done(() => {
                    var linkItem = $(`[data-id='${linkId}']`);
                    linkItem.remove();

                    var link = this.siteManagerView.getObjectFromSiteById(linkId);
                    this.siteTreeBuilder.linksControls[deviceId].appendLinkToAddDropdown(link, deviceId, outputName);
                }).fail(() => {
                    alert("failed to deactivate link");
                });
        });
    }

    public configureNumberOfLanes(roadId: string, lanes: number): void {
        this.siteManagerView.changeUserLevel(ViewModelUserLevel.AuthorizedClient).then(() => {
            $.ajax({
                url: "/api/SiteEdit/ConfigureLaneNumber",
                method: "POST",
                data: {
                    Id: roadId,
                    Value: lanes
                }
            }).done(() => {
                this.siteManagerView.forceSiteModelAndViewUpdate();
            }).fail(err => {
                this.siteManagerView.showAlertMessage(Localization.resourceStrings.SiteView_ErrorConfigureLanes, err.responseJSON.Message, Localization.resourceStrings.SiteView_ErrorExceptionMessageTemplate);
            });
        });
    }

    public addRoad(roads?: LocationViewModel[]): void {
        this.siteManagerView.changeUserLevel(ViewModelUserLevel.AuthorizedClient).then(() => {
            $.ajax({
                url: "/api/SiteEdit/GetElementTypes?type=Road"
            }).done((roadTypes: ElementTypeViewModel[]) => {
                if (roads) {
                    for (var i = 0; i < roads.length; i++) {
                        var title = Localization.resourceStrings.SiteView_RoadConfigCopyTitle
                            .replace("{0}", roads[i].SequenceNumber.toString())
                            .replace("{1}", roads[i].Title != "" ? roads[i].Title : Localization.resourceStrings.SiteView_EditableEmptyText);
                        var roadAsType: ElementTypeViewModel = {
                            Description: roads[i].Description,
                            IconId: "$locationCopy",
                            Id: roads[i].Id,
                            SequenceNumber: roads[i].SequenceNumber,
                            Title: title
                        }

                        roadTypes.push(roadAsType);
                    }
                }

                this.showModalAddDialog(Localization.resourceStrings.SiteView_ButtonAddRoad, roadTypes, "/api/SiteEdit/AddRoad/", true)
            }).fail(err =>
                this.siteManagerView.showAlertMessage(Localization.resourceStrings.SiteView_ErrorGetRoadTypes, err.responseJSON.Message, Localization.resourceStrings.SiteView_ErrorExceptionMessageTemplate)
            );
        });
    }

    public addDevice(parentId): void {
        this.siteManagerView.changeUserLevel(ViewModelUserLevel.AuthorizedClient).then(() => {
            $.ajax({
                url: `/api/SiteEdit/GetElementTypes?type=Device&roadConfigId=${parentId}`
            }).done(deviceTypes =>
                this.showModalAddDialog(Localization.resourceStrings.SiteView_ButtonAddDevice, deviceTypes, "/api/SiteEdit/AddDevice/", true, parentId)
            ).fail(err =>
                this.siteManagerView.showAlertMessage(Localization.resourceStrings.SiteView_ErrorGetDeviceTypes, err.responseJSON.Message, Localization.resourceStrings.SiteView_ErrorExceptionMessageTemplate)
            );
        });
    }

    public addPlugin(): void {
        this.siteManagerView.changeUserLevel(ViewModelUserLevel.AuthorizedClient).then(() => {
            $.ajax({
                url: "/api/SiteEdit/GetElementTypes?type=Plugin"
            }).done(pluginTypes =>
                this.showModalAddDialog(Localization.resourceStrings.SiteView_ButtonAddPlugin, pluginTypes, "/api/SiteEdit/AddPlugin/", true)
            ).fail(err =>
                this.siteManagerView.showAlertMessage(Localization.resourceStrings.SiteView_ErrorGetPluginTypes, err.responseJSON.Message, Localization.resourceStrings.SiteView_ErrorExceptionMessageTemplate)
            );
        });
    }

    private showModalAddDialog(title: string, elements: ElementTypeViewModel[], url: string, autoAddIfOne: boolean, parentId?: string): void {
        var tbody = $("#modalAddElement").find("tbody");
        tbody.html("");

        tbody.unbind("click");

        if (elements.length > 0) {
            for (var i = 0, len = elements.length; i < len; i++) {
                var element = elements[i];
                tbody.append(`<tr data-element-id='${element.Id}' ${parentId ? `data-parent-id='${parentId}'` : ""} style='cursor: pointer;'>
                                            <td><img class='element-image' src='/api/Info/GetIcon/${element.IconId}' /></td>
                                            <td>${element.Title}</td>
                                            <td>${element.Description}</td>
                                        </tr>`);
            }

            tbody.on("click", "tr", (event) => {
                $.ajax({
                    url: url,
                    method: "POST",
                    data: {
                        elementTypeId: $(event.currentTarget).data("element-id"),
                        roadConfigId: $(event.currentTarget).data("parent-id")
                    }
                }).done(() => {
                    this.siteManagerView.forceSiteModelAndViewUpdate();
                    $("#modalAddElement").modal("hide");
                }).fail(err => {
                    this.siteManagerView.showAlertMessage(Localization.resourceStrings.SiteView_ErrorAddElement, err.responseJSON.Message, Localization.resourceStrings.SiteView_ErrorExceptionMessageTemplate);
                });
            });
        } else {
            tbody.append(`<tr><td colspan="3">${Localization.resourceStrings.SiteTreeView_NoElementsFoundMessage}</td></tr>`);
        }

        if (autoAddIfOne && elements.length === 1) {
            tbody.children("tr").click();
        } else {
            $("#modalAddElementSearch").val(null);
            $("#modalAddElementTitle").text(title);
            $("#modalAddElement").modal("show");
            setTimeout(() => $("#modalAddElementSearch").focus(), 200); // modal("show") does some magic stuff...
        }
    }

    private modalAddElementFilterEntries() {
        const searchText = ($("#modalAddElementSearch").val() as string).toLowerCase();

        var $table = $("#modalAddElement").find("table");
        $table.css('min-width', $table.width() + 'px'); // Fix width, in case largest is filtered
        var tableRows = $table.find("tr");

        $.each(tableRows, (idx, rowDom) => {
            const row = $(rowDom);
            var text = $.map(row.children() as any, el => $(el).text())
                .join("$$$") // insert a 'crazy' delimiter between the table cells (overall easier than searching in each individual cell)
                .replace(/(\r\n|\n|\r)/gm, "");

            //  var searchRegex = new RegExp(searchText, "i");
            // used to be text.matches(seachRegex) !== null;   but that would probably be too complicated for the user
            var matches = text.toLowerCase().indexOf(searchText) >= 0;
            row.toggle(matches);
        });
    }

    public deleteElement(id) {
        this.siteManagerView.changeUserLevel(ViewModelUserLevel.AuthorizedClient).then(() => {
            var self = this;
            var sendDeleteRequest = () => {
                $.ajax({
                    url: `/api/SiteEdit/DeleteSiteElement/${id}`,
                    method: "DELETE"
                }).done(() => {
                    self.siteManagerView.forceSiteModelAndViewUpdate();
                }).fail(err => {
                    this.siteManagerView.showAlertMessage(Localization.resourceStrings.SiteView_ErrorDelete.replace("{0}", id), err.responseJSON.Message, Localization.resourceStrings.SiteView_ErrorExceptionMessageTemplate);
                });
            };

            let textBody = Localization.resourceStrings.SiteView_MessageDelete;
            let textTitle = `<span class='glyphicon glyphicon-alert'></span> ${Localization.resourceStrings.SiteView_TitleDelete}`;
            let buttonDelete = {
                Text: Localization.resourceStrings.SiteView_ButtonDelete,
                ClickHandler: () => {
                    this.siteManagerView.hideAcknowledgementModal();
                    sendDeleteRequest();
                },
                Visible: true
            };
            this.siteManagerView.showAcknowledgementModal(textBody, textTitle, buttonDelete);
        });
    }

    private triggerLinesChanged(deviceId: string) {
        const newTriggerLocations = this.siteTreeBuilder.triggerControls[deviceId].TriggerLocations;

        this.pendingTriggerUpdates[deviceId] = newTriggerLocations;

        // Start the upload with a short delay in case other updates follow with a short delay
        if (this.pendingTriggerUpdateHandle == null) {
            this.pendingTriggerUpdateHandle = window.setTimeout(() => this.saveElementTriggerLocations(), 500);
        }
    }

    private saveElementTriggerLocations() {

        this.siteManagerView.changeUserLevel(ViewModelUserLevel.AuthorizedClient).then(() => {
            let triggerUpdates = this.pendingTriggerUpdates;
            this.pendingTriggerUpdates = {};

            if (Object.keys(triggerUpdates).length > 0) {
                $.ajax({
                    url: "/api/SiteEdit/SaveElementTriggerLocations",
                    method: "POST",
                    contentType: "application/json; charset=utf-8",
                    data: JSON.stringify(triggerUpdates),
                }).done(() => {
                    this.siteManagerView.forceSiteModelAndViewUpdate();

                    // Restart the update in case there are new updates in the mean time
                    this.pendingTriggerUpdateHandle = window.setTimeout(() => this.saveElementTriggerLocations(), 200);
                }).fail(err => {
                    this.siteManagerView.showAlertMessage(Localization.resourceStrings.SiteView_SaveTriggerFailed, err.responseJSON.Message, Localization.resourceStrings.SiteView_ErrorExceptionMessageTemplate);
                    this.pendingTriggerUpdateHandle = null;
                });
            } else {
                this.pendingTriggerUpdateHandle = null;
            }
        });
    }

    private devicePositionChanging(deviceId: string) {
        // get position
        let newOrientation = this.siteManagerView.siteView.getDevicePosition(deviceId);
        if (newOrientation) {
            this.pendingPositionUpdates[deviceId] = newOrientation;

            // Start the upload with a short delay in case other updates follow with a short delay
            if (this.pendingPositionUpdateHandle == null) {
                this.pendingPositionUpdateHandle = window.setTimeout(() => this.saveElementPositions(), 200);
            }
        }
    }

    private saveElementPositions(): void {

        let positionUpdates = this.pendingPositionUpdates;
        this.pendingPositionUpdates = {};

        if (Object.keys(positionUpdates).length > 0) {
            this.siteManagerView.changeUserLevel(ViewModelUserLevel.AuthorizedClient).then(() => {
                $.ajax({
                    url: "/api/SiteEdit/SaveElementPositionChanges",
                    method: "POST",
                    data: positionUpdates
                }).done(() => {
                    this.siteManagerView.forceSiteModelUpdate();
                    for (let posId in positionUpdates) {
                        TemsWebEvents.publishEvent(TemsWebEvents.DevicePositionChanged, [posId, positionUpdates[posId]]);
                    }

                    // Restart the update in case there are new updates in the mean time
                    this.pendingPositionUpdateHandle = window.setTimeout(() => this.saveElementPositions(), 200);

                }).fail(err => {
                    this.siteManagerView.showAlertMessage(Localization.resourceStrings.SiteView_ErrorUpdatePosition, err.responseJSON.Message, Localization.resourceStrings.SiteView_ErrorExceptionMessageTemplate);
                    this.pendingPositionUpdateHandle = null;
                });
            });
        } else {
            this.pendingPositionUpdateHandle = null;
        }
    }

    public resetSetupSiteConfig() {
        this.siteManagerView.changeUserLevel(ViewModelUserLevel.AuthorizedClient).then(() => {
            $.ajax({
                url: "/api/SiteEdit/ResetSetupSiteConfig",
                method: "POST",
            }).done(() => {
                this.siteManagerView.forceSiteModelUpdate();
            }).fail(err => {
                this.siteManagerView.showAlertMessage(Localization.resourceStrings.LayoutView_ErrorTitleGeneral, err.responseJSON.Message, Localization.resourceStrings.SiteView_ErrorExceptionMessageTemplate);
            });
        });
    }

    showElementDetails(id: string) {
        this.deviceDetailsView.showElementDetails(id);
    }
}

